<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27.934 26.535"
        style="fill: currentColor"
    >
        <g id="cash-register-machine" transform="translate(-566.527 -324)">
            <path
                id="cash-register-machine-2"
                data-name="cash-register-machine"
                d="M24.5,12.035l0-.02A2.686,2.686,0,0,0,21.9,10H19.281V8.5h3.78a.766.766,0,0,0,.766-.766V5.329a.766.766,0,0,0-.766-.766H13.968a.766.766,0,0,0-.766.766V7.736a.766.766,0,0,0,.766.766h3.78V10H6.037a2.686,2.686,0,0,0-2.6,2.011l0,.021L.819,23.376c.073-.006.145-.011.219-.011H26.9c.074,0,.147,0,.219.011ZM22.13,15.579a.766.766,0,0,1-.766.766H6.57a.766.766,0,0,1-.766-.766V13.792a.766.766,0,0,1,.766-.766H21.364a.766.766,0,0,1,.766.766ZM26.9,24.9H1.038A1.039,1.039,0,0,0,0,25.936V30.06A1.039,1.039,0,0,0,1.038,31.1H26.9a1.039,1.039,0,0,0,1.038-1.038V25.936A1.039,1.039,0,0,0,26.9,24.9Zm-10.59,3.225a1.416,1.416,0,0,1-1.415,1.415H13.154a1.416,1.416,0,0,1-1.415-1.415v-.25a1.416,1.416,0,0,1,1.415-1.415h1.736a1.416,1.416,0,0,1,1.415,1.415v.25Z"
                transform="translate(566.527 319.437)"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-folder",
});
</script>
